import { createListenerMiddleware } from '@reduxjs/toolkit';
import { handleQueryError } from 'store/utils';

import { insightsReportApi } from './insightsReportApi';

import type { RootState } from 'store';

export const insightsReportApiLister = createListenerMiddleware<RootState>();

insightsReportApiLister.startListening({
  matcher: insightsReportApi.endpoints.validateReportPin.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to validate PIN');
  },
});
